import { getLocationDisplay } from '../../../../../../locations/components/LocationSelect/LocationSelect.utils';
import { validateRequiredField } from '../DynamicFormFields/DynamicFormFields.utils';
export function validateFormField(field, value) {
  return validateRequiredField(field, value);
}
export function getOptions(locations) {
  return (locations || []).map(function (location) {
    var displayName = getLocationDisplay(location);
    return {
      key: displayName,
      value: displayName,
      text: displayName
    };
  });
}